import React from 'react';
import './social-share-btns.scss';
import tracker from '../../../../utils/tracker';
import {
    FacebookShareButton,
    WhatsappShareButton,
    EmailShareButton
} from 'react-share';
import { slice } from 'lodash';

const SocialShareButtons = (props) => {
    const { title, link, subjectTitle, description } = props;

    const words = description.split(" ");
    const desc = slice(words, 0, 20);
    
    return (
        <div className="pw-social-share-btn-group">
            <div className="pw-ss-btn-container">
                <div className="pw-ss-buttons">
                    <div className="pw-ss-button">
                        <FacebookShareButton
                            beforeOnClick={() => tracker.trackSocial('Facebook', window.location.href)}
                            url={link}
                            quote={title}
                        >
                            <span className="pw-ss-icon pw-ss-facebook" />
                        </FacebookShareButton>
                    </div>
                    <div className="w3-hide pw-ss-button">
                        <span className="pw-ss-icon pw-ss-instagram" />
                    </div>
                    <div className="pw-ss-button">
                        <WhatsappShareButton
                            beforeOnClick={() => tracker.trackSocial('Whatsapp', window.location.href)}
                            url={link}
                            title={`${'*'}${title}${'*'}${'\n'}${words.length > 20 ? `${desc.join(' ')}...${'\n'}` : `${desc.join(' ')}${'\n'}`}`}
                        >
                            <span className="pw-ss-icon pw-ss-whatsapp" />
                        </WhatsappShareButton>
                    </div>
                    <div className="pw-ss-button">
                        <EmailShareButton
                            beforeOnClick={() => tracker.trackSocial('Email', window.location.href)}
                            url={link}
                            subject={`${subjectTitle}${' '}${' '}${title}`}
                            body={words.length > 20 ? `${desc.join(' ')}...${'\n'}` : `${desc.join(' ')}${'\n'}`}
                        >
                            <span className="pw-ss-icon pw-ss-mail" />
                        </EmailShareButton>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SocialShareButtons;